<ul
  role="tree"
  unselectable="on"
  [ngClass]="dwTreeClass">
  <dw-tree-node
    *ngFor="let node of dwNodes"
    [dwTreeNode]="node"
    [dwShowLine]="dwShowLine"
    [dwDraggable]="dwDraggable"
    [dwCheckable]="dwCheckable"
    [dwShowExpand]="dwShowExpand"
    [dwAsyncData]="dwAsyncData"
    [dwMultiple]="dwMultiple"
    [dwSearchValue]="dwSearchValue"
    [dwBeforeDrop]="dwBeforeDrop"
    [dwCheckStrictly]="dwCheckStrictly"
    [dwExpandAll]="dwExpandAll"
    [dwDefaultExpandAll]="dwDefaultExpandAll"
    [dwTreeTemplate]="dwTreeTemplate"
    (clickNode)="dwClick.emit($event)"
    (dblClick)="dwDblClick.emit($event)"
    (contextMenu)="dwContextMenu.emit($event)"
    (clickExpand)="dwExpandChange.emit($event)"
    (clickCheckBox)="dwCheckBoxChange.emit($event)"
    (dwDragStart)="dwOnDragStart.emit($event)"
    (dwDragEnter)="dwOnDragEnter.emit($event)"
    (dwDragOver)="dwOnDragOver.emit($event)"
    (dwDragLeave)="dwOnDragLeave.emit($event)"
    (dwDrop)="dwOnDrop.emit($event)"
    (dwDragEnd)="dwOnDragEnd.emit($event)">
  </dw-tree-node>
</ul>